import CustomView from "../custom-view"
import {ViewAccess} from "../../../gd/const/views/view-type-config"
import delete_project from "../../../gd-ui/more/project/actions/delete-project"

const debug = false
// const debug = "CustomViewActions"

export default class CustomViewActions {

    public view     : CustomView

    constructor(view:CustomView) {
        this.view = view
    }

    delete = async () => {

        if(this.view.inProjectStructure) {
            delete_project(this.view.parentProjectId!)
            return
        }

        gd.modals.confirm.deleteByName('View',this.view.name, async ()=>{
            debug && console.log(debug, 'delete', this.view)

            await gd.api.Views.deleteView(this.view.id).promise()

            if (this.view.inNavigationPanel) {
                debug && console.log(debug, 'removeFromNavigationPanel', this.view.viewId, gd.layout.navigation.navigationStructure)
                gd.layout.navigation.navigationStructure.remove(this.view.viewId)
                gd.layout.navigation.navigationStructure.initSections()
                gd.layout.navigation.navigationStructure.saveSortPositions()
                gd.layout.navigation.reRender()
            }

            gd.modal.hide()
            if (this.view.isOpen()) gd.goTo('my-work')
        })
    }

    addUsers = (callback:callback) => {
        const hiddenUsersIds = _.compact([this.view.userId].concat(this.view.sharedUsers))

        gd.modals.other.addUsers(null, hiddenUsersIds, true, null, (result:any)=>{
            const newUsersIds = _.map(result, u=>u.userId)

            this.view.sharedUsers = _.compact(_.union(this.view.sharedUsers, newUsersIds))
            this.view.access = _.isEmpty(this.view.sharedUsers) ? ViewAccess.PRIVATE : ViewAccess.SHARED
            this.view.save()

            callback && callback(newUsersIds)
        })
    }
}
